export default __webpack_public_path__ + "static/media/FightSound.34398866.mp3";